export default __webpack_public_path__ + "static/media/extra extra large.7da82b8e.png";